export const AddContentFavorite = 'AddFavoriteContent';
export const AddFieldToSortOrder = 'AddFieldToSortOrder';
export const AddToContentSelection = 'AddToContentSelection';
export const AvailableActionsForEntityRequest = 'AvailableActionsForEntityRequest';
export const AvailableActionsForEntityRequestSucceeded = 'AvailableActionsForEntityRequestSucceeded';
export const CancelBackgroundJob = 'CancelBackgroundJob';
export const ChangeExtractRefreshSchedule = 'ChangeExtractRefreshSchedule';
export const ChangeRecommendationType = 'ChangeRecommendationType';
export const ChangeRemoteExtractRefresh = 'ChangeRemoteExtractRefresh';
export const ChangeRemoteExtractRefreshExpectedDuration = 'ChangeRemoteExtractRefreshExpectedDuration';
export const ChangeSubscriptionDataCondition = 'ChangeSubscriptionDataCondition';
export const ChangeSubscriptionsFrequency = 'ChangeSubscriptionsFrequency';
export const ChangeSubscriptionsFormat = 'ChangeSubscriptionsFormat';
export const ChangeSubscriptionsSchedule = 'ChangeSubscriptionsSchedule';
export const ChangeSubscriptionSubject = 'ChangeSubscriptionSubject';
export const ClearMixedContentFilters = 'ClearMixedContentFilters';
export const ClearFilterContent = 'ClearFilterContent';
export const ContentCountsRequest = 'ContentCountsRequest';
export const ContentCountsRequestSucceeded = 'ContentCountsRequestSucceeded';
export const ContentCountsUpToDate = 'ContentCountsUpToDate';
export const ContentFavoriteAdded = 'FavoriteContentAdded';
export const ContentFavoriteRemoved = 'ContentFavoriteRemoved';
export const ContentFilterApplied = 'ContentFilterApplied';
export const ContentTypeFilterSelected = 'ContentTypeFilterSelected';
export const CreateExtractRefresh = 'CreateExtractRefresh';
export const CreateExtracts = 'CreateExtracts';
export const CreateNewContentInfoRequest = 'CreateNewContentInfoRequest';
export const CreateNewFlow = 'CreateNewFlow';
export const CreateNewProject = 'CreateNewProject';
export const CreateNewSchedule = 'CreateNewSchedule';
export const CreateNewSite = 'CreateNewSite';
export const CreateNewWorkbook = 'CreateNewWorkbook';
export const CreateRemoteExtractRefresh = 'CreateRemoteExtractRefresh';
export const DataAlertAddMe = 'DataAlertAddMe';
export const DataAlertEdit = 'DataAlertEdit';
export const DataAlertRemoveMe = 'DataAlertRemoveMe';
export const DataAlertResume = 'DataAlertResume';
export const DeleteContents = 'DeleteContents';
export const DeleteContentsSucceeded = 'DeleteContentsSucceeded';
export const DeleteExtractRefresh = 'DeleteExtractRefresh';
export const DeleteRemoteExtractRefresh = 'DeleteRemoteExtractRefresh';
export const DeselectAll = 'DeselectAll';
export const Download = 'Download';
export const EditConnections = 'EditConnections';
export const EditFlow = 'EditFlow';
export const EditView = 'EditView';
export const EditWorkbook = 'EditWorkbook';
export const EncryptContent = 'EncryptContent';
export const EnterFlowSubspace = 'EnterFlowSubspace';
export const EnterSpace = 'EnterSpace';
export const ExtractContent = 'ExtractContent';
export const GetContentDetail = 'GetContentDetail';
export const FilterContent = 'FilterContent';
export const FilterContentType = 'FilterContentType';
export const LaunchRevisionHistory = 'LaunchRevisionHistory';
export const MoveContents = 'MoveContents';
export const MoveContentsSucceeded = 'MoveContentsSucceeded';
export const NewWorkbookForDatasource = 'NewWorkbookForDatasource';
export const NewMetricForDatasource = 'NewMetricForDatasource';
export const OpenCancelBackgroundJobDialog = 'OpenCancelBackgroundJobDialog';
export const SpaceContentsRequest = 'SpaceContentRequest';
export const SpaceContentsRequestSucceeded = 'SpaceContentRequestSucceeded';
export const SpaceContentsRequestFailed = 'SpaceContentRequestFailed';
export const SpaceContentsMissingSliceRequest = 'SpaceContentsMissingSliceRequest';
export const SpaceContentsSliceSucceeded = 'SpaceContentsSliceSucceeded';
export const ToggleBackgroundJobExtendedInfoDialog = 'ToggleBackgroundJobExtendedInfoDialog';
export const RefreshSessionInfo = 'RefreshSessionInfo';
export const RecommendationHidden = 'RecommendationHidden';
export const RecommendationUnhidden = 'RecommendationUnhidden';
export const RemoveAlert = 'RemoveAlert';
export const RemoveContentFavorite = 'RemoveFavoriteContent';
export const RemoveExternalContentAction = 'RemoveExternalContentAction';
export const RemoveFavoritedItemAction = 'RemoveFavoritedItemAction';
export const RemoveFromContentSelection = 'RemoveFromContentSelection';
export const RenameContent = 'RenameContent';
export const RequestFailed = 'RequestFailed';
export const ResumeExtractRefresh = 'ResumeExtractRefresh';
export const ResumeSubscription = 'ResumeSubscription';
export const RunExtractRefresh = 'RunExtractRefresh';
export const RunFlow = 'RunFlow';
export const RunFlowTaskRunNow = 'RunFlowTaskRunNow';
export const RunFlowTaskChangeSchedule = 'RunFlowTaskChangeSchedule';
export const RunFlowTaskChangePriority = 'RunFlowTaskChangePriority';
export const RunFlowTaskResume = 'RunFlowTaskResume';
export const ScheduleRunNow = 'ScheduleRunNow';
export const ScheduleEnable = 'ScheduleEnable';
export const ScheduleDisable = 'ScheduleDisable';
export const ScheduleEdit = 'ScheduleEdit';
export const SelectAll = 'SelectAll';
export const SelectionStart = 'SelectionStart';
export const SelectionStop = 'SelectionStop';
export const SelectSortOrder = 'SelectSortOrder';
export const SetAndSavePreviousFilterPanelVisibility = 'SetAndSavePreviousFilterPanelVisibility';
export const SetContentFilterNoRequestContent = 'SetContentFilterNoRequestContent';
export const SetContentPermissions = 'SetContentPermissions';
export const SetFromPreviousFilterPanelVisibilty = 'SetFromPreviousFilterPanelVisibilty';
export const SetLayoutType = 'SetLayoutType';
export const SetExtractRefreshPriority = 'SetExtractRefreshPriority';
export const SetNavLocation = 'SetNavLocation';
export const SetOrder = 'SetOrder';
export const SetOwner = 'SetOwner';
export const SetOwnerSucceeded = 'SetOwnerSucceeded';
export const SetPreviousUrl = 'SetPreviousUrl';
export const SetRemoteExtractRefreshProperties = 'SetRemoteExtractRefreshProperties';
export const SetRootAdminUiState = 'SetRootAdminUiState';
export const SetSpaceInfoItem = 'SetSpaceInfoItem';
export const SetTabsWorkbook = 'SetTabsWorkbook';
export const SetTags = 'SetTags';
export const ShareContent = 'ShareContent';
export const ShowContentTypes = 'ShowContentTypes';
export const SiteSuspend = 'SiteSuspend';
export const SiteActivate = 'SiteActivate';
export const SiteEdit = 'SiteEdit';
export const SiteDelete = 'SiteDelete';
export const SiteNamesRequest = 'SiteNamesRequest';
export const SitesNamesRequestSucceeded = 'SitesNamesRequestSucceeded';
export const SortContent = 'SortContent';
export const ToggleShowWorkbooksAsViews = 'ToggleShowWorkbooksAsViews';
export const DeleteSubscriptions = 'DeleteSubscriptions';
export const UndoHideRecommendation = 'UndoHideRecommendation';
export const UpdateAlerts = 'UpdateAlerts';
export const UpdateAlertTotal = 'UpdateAlertTotal';
export const UpdateBreadcrumbs = 'UpdateBreadcrumbs';
export const UpdateBreadcrumbHref = 'UpdateBreadcrumbHref';
export const UpdateContentDetail = 'UpdateContentDetail';
export const UpdateExplorerDisplayMode = 'UpdateExplorerDisplayMode';
export const UpdateExplorerDisplayModeInternal = 'UpdateExplorerDisplayModeInternal';
export const UpdateFilterPanelVisibility = 'UpdateFilterPanelVisibility';
export const UpdateSpaceInfoCount = 'UpdateSpaceInfoCount';
export const UpdateFiltersInBothUrlAndState = 'UpdateFiltersInBothUrlAndState';
export const UpdateMetricsValues = 'UpdateMetricsValues';
export const UpdateMetricsValuesSucceeded = 'UpdateMetricsValuesSucceeded';
export const UpdateUserSettings = 'UpdateUserSettings';
export const WhoHasSeenThisView = 'WhoHasSeenThisView';
export const HideRecommendation = 'HideRecommendation';
export const HomeFetchFavoritesSucceeded = 'HomeRequestFavoritesSucceeded';
export const HomeFetchRecentsSucceeded = 'HomeRequestRecentsSucceeded';
export const HomeFetchPopularSucceeded = 'HomeRequestPopularSucceeded';
export const HomeFetchRecommendationsSucceeded = 'HomeRequestRecommendationsSucceeded';
export const HomeAddFavoriteSucceeded = 'HomeAddFavoriteSucceeded';
export const HomeRemoveFavoriteSucceeded = 'HomeRemoveFavoriteSucceeded';
export const HomeCloseWelcomeChannel = 'HomeCloseWelcomeChannel';
export const HomeGetWelcomeChannelInfo = 'HomeGetWelcomeChannelInfo';
export const HomeUpdateShowWelcomeChannel = 'HomeUpdateShowWelcomeChannel';
export const SetDataQuality = 'SetDataQuality';
export const ChangeExtractDsToLive = 'ChangeExtractDsToLive';
export const SetDescription = 'SetDescription';
export const SetContact = 'SetContact';
export const SetCertification = 'SetCertification';
export const SiteUserAddUsers = 'SiteUserAddUsers';
